<template>
  <div class="SearchDropDownContainer" :style="styleWidth" :disabled="disabled">
    <div
      ref="SearchDropDown"
      class="SearchDropDown"
      @click.stop="SearchDropDownClick"
      contenteditable="true"
      v-on:keydown="ddlKeyDown"
      v-bind:title="this.title"
    >
      {{ selectedItem[textField] }}
    </div>
    <div
      class="SearchDropDownListBox"
      :style="{ width: attr.boxWidth }"
      @click.stop
    >
      <div class="SearchDropDownSearch glyphicons search">
        <input type="search" @keydown="onKeyDown" v-model="searchText" />
      </div>
      <div class="SearchDropDownList">
        <div
          class="SearchDropDownItem"
          v-for="listItem in getListData"
          v-bind:key="listItem[valueField]"
          @click="SelectItem(listItem, $event)"
          v-bind:selected="listItem === currentSelItem"
          v-bind:searchkey="
            listItem[searchField || textField].toString().toLowerCase()
          "
        >
          {{ listItem[textField] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listData: { type: Array, required: true },
    valueField: { type: String, default: "value" },
    textField: { type: String, default: "text" },
    firstItem: { type: String, default: "" },
    searchField: String,
    value: { default: "" },
    title: String,
    width: String,
    disabled: { type: Boolean, default: false },
  },
  model: {
    event: "input",
    event: "change",
  },
  data() {
    return {
      attr: {
        isOpen: false,
        boxWidth: "100%",
      },
      selectedItem: {},
      searchText: "",
      currentSelItem: {},
    };
  },
  methods: {
    SearchDropDownClick(e) {
      if (e.target.closest("[disabled]")) {
        return;
      }
      this.searchText = "";

      this.attr.boxWidth =
        e.target.closest(".SearchDropDownContainer").offsetWidth + "px";
      let SearchDropDownContainer = e.target.parentNode;
      let SearchDropDownListBox = SearchDropDownContainer.querySelector(
        ".SearchDropDownListBox"
      );
      document.querySelectorAll(".SearchDropDownListBox").hide();
      SearchDropDownListBox.showAsDropDown(SearchDropDownContainer);
      document.body.one("click", function () {
        SearchDropDownListBox.hide();
      });
      SearchDropDownListBox.querySelector('input[type="search"]').focus();
      window.setTimeout(function () {
        let selItem = SearchDropDownListBox.querySelector(
          ".SearchDropDownItem[selected]"
        );
        if (selItem) {
          selItem.scrollIntoView();
        }
      });
    },
    ddlKeyDown(e) {
      if (e.target.closest("[disabled]")) {
        if (e.which != 9) {
          e.stopPropagation();
          e.preventDefault();
        }
        return;
      }
      if (e.which !== 9 && e.which !== 27) {
        this.searchText = "";
        let SearchDropDownContainer = e.target.parentNode;
        let SearchDropDownListBox = SearchDropDownContainer.querySelector(
          ".SearchDropDownListBox"
        );
        SearchDropDownListBox.showAsDropDown(SearchDropDownContainer);
        document.body.one("click", function () {
          SearchDropDownListBox.hide();
        });
        SearchDropDownListBox.querySelector('input[type="search"]').focus();
        window.setTimeout(function () {
          let selItem = SearchDropDownListBox.querySelector(
            ".SearchDropDownItem[selected]"
          );
          if (selItem) {
            selItem.scrollIntoView();
          }
        });
      }
    },
    SelectItem(listItem, e) {
      this.selectedItem = listItem;
      this.currentSelItem = listItem;
      this.$emit("input", listItem[this.valueField]);
      this.$emit("change", listItem[this.valueField]);
      e.target
        .closest(".SearchDropDownContainer")
        .classList.remove("invalidInput");
      e.target
        .closest(".SearchDropDownContainer")
        .querySelector(".SearchDropDownListBox")
        .hide();
      window.setTimeout(function () {
        e.target
          .closest(".SearchDropDownContainer")
          .querySelector(".SearchDropDown")
          .focus();
      });
    },
    onKeyDown(e) {
      if (e.target.closest("[disabled]")) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
      if (e.which === 38) {
        let listData = this.getListData;
        let index = listData.indexOf(this.currentSelItem);
        if (index > 0) {
          this.currentSelItem = listData[index - 1];
          window.setTimeout(function () {
            let selItem = e.target
              .closest(".SearchDropDownListBox")
              .querySelector(".SearchDropDownItem[selected]");
            if (selItem) {
              selItem.scrollIntoView(true);
            }
          });
        }
      } else if (e.which === 40) {
        let listData = this.getListData;
        let index = listData.indexOf(this.currentSelItem);
        if (index < listData.length - 1) {
          this.currentSelItem = listData[index + 1];
          window.setTimeout(function () {
            let selItem = e.target
              .closest(".SearchDropDownListBox")
              .querySelector(".SearchDropDownItem[selected]");
            if (selItem) {
              selItem.scrollIntoView(false);
            }
          });
        } else {
          // console.log(this.currentSelItem);
        }
      } else if (e.which === 13) {
        e.target
          .closest(".SearchDropDownListBox")
          .querySelector(".SearchDropDownItem[selected]")
          .click();
      } else if (e.which === 27 || e.which === 9) {
        e.target.closest(".SearchDropDownListBox").hide();
        e.target
          .closest(".SearchDropDownContainer")
          .querySelector(".SearchDropDown")
          .focus();
      }
    },
    focus() {
      this.$refs.SearchDropDown.focus();
    },
  },
  computed: {
    styleWidth() {
      return this.width ? "width:" + this.width + ";" : "";
    },
    getListData() {
      let list = [];
      if (this.firstItem) {
        let newItem = {};
        newItem[this.valueField] = "-1";
        newItem[this.textField] = this.firstItem;
        list.push(newItem);
      }
      for (let i = 0; i < this.listData.length; i++) {
        if (this.searchText) {
          let regX = new RegExp(this.searchText, "i");
          if (regX.test(this.listData[i][this.textField])) {
            list.push(this.listData[i]);
          }
        } else {
          list.push(this.listData[i]);
        }
      }
      return list;
    },
    classList() {
      return this.$refs.SearchDropDown.classList;
    },
  },
  created() {
    let listData = this.getListData;
    for (let i = 0; i < listData.length; i++) {
      if (listData[i][this.valueField] == this.value) {
        this.selectedItem = listData[i];
        this.currentSelItem = listData[i];
      }
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      let fItems = this.getListData.filter((item) => {
        return item[this.valueField] == newValue;
      });
      if (fItems.length > 0) {
        this.selectedItem = fItems[0];
        this.currentSelItem = fItems[0];
      }
    },
  },
  mounted() {
    window.ekkJS.setToolTips();
  },
  updated() {
    let fItems = this.getListData.filter((item) => {
      return item[this.valueField] == this.value;
    });
    if (fItems.length > 0) {
      this.selectedItem = fItems[0];
    }
  },
};
</script>
<style scoped>
.SearchDropDownContainer {
  color: #000;
  border: solid 1px;
  border-radius: 2px;
  position: relative;
  background-color: #f5f5f5;
  box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.2);
}
.SearchDropDownContainer:focus {
  border-color: blue;
}
.SearchDropDownContainer.invalidInput {
  border: solid 1px red;
  background-image: linear-gradient(rgba(255, 0, 0, 0.1));
  background-color: white !important;
  box-shadow: none;
}
.SearchDropDown {
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  padding: 3px;
  margin-right: 21px;
}

.SearchDropDown.ItemSelected {
  color: black;
}

.SearchDropDown:after {
  content: "▼";
  position: absolute;
  top: 3px;
  right: 5px;
}
.SearchDropDownListBox {
  width: 100%;
  border: solid 1px;
  background-color: #fff;
  color: #000;
  position: fixed;
  display: none;
  z-index: 1;
}
.SearchDropDownListBox.Open {
  display: block;
}
.SearchDropDownSearch {
  padding: 5px;
  position: relative;
  width: 100%;
}
.SearchDropDownSearch:before {
  position: absolute;
  left: 10px;
}
.SearchDropDownSearch input[type="search"] {
  padding-left: 25px;
  width: 100%;
}
.SearchDropDownList {
  width: 100%;
  border: solid 1px;
  max-height: 200px;
  overflow: auto;
}
.SearchDropDownItem {
  padding: 5px;
  border: solid 1px #bfbfbf;
  cursor: default;
}
.SearchDropDownItem:hover {
  background-color: #bfbfbf;
}
.SearchDropDownItem[selected="selected"] {
  background-color: rgb(40, 40, 247);
  color: white;
}
.SearchDropDownItem[hidden] {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/SearchDropDown.vue